import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./AccountDeleted.css";

const REDIRECT_MS = 20000;

export default function AccountDeleted() {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => navigate("/", { replace: true }), REDIRECT_MS);
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="deleted">
      <div className="deleted__card">
        <p className="deleted__emoji" aria-hidden="true">🙁</p>
        <h1 className="deleted__title">Sorry we lost you</h1>
        <p className="deleted__body">
          Your account has been paused and is scheduled for permanent deletion in 90 days. If you change your mind,
          simply log in within this period to restore your account.
        </p>
      </div>
    </div>
  );
}
